<div class="flex items-center gap-1">
    @for (lang of languages; track lang.code){
        <button (click)="setLang(lang.code)"
                class="transition-all active:scale-95"
                [class.opacity-40]="currentLang() !== lang.code"
                [class.grayscale]="currentLang() !== lang.code"
                [title]="lang.name">
            <img [src]="lang.flag"
                 class="w-6 h-6 rounded-full object-cover border border-gray-200 shadow-sm"
                 [class.ring-2]="currentLang() === lang.code"
                 [class.ring-primary]="currentLang() === lang.code"
                 [class.ring-offset-2]="currentLang() === lang.code">
        </button>
    }
</div>
